import { featuresItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 border border-accent-200/60 text-accent-700 text-xs font-semibold mb-4 whitespace-nowrap">
            <i className="ri-star-line text-sm"></i>
            平台特色
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">为什么选择黑料吃瓜网</h2>
          <p className="text-sm text-foreground-500 max-w-2xl mx-auto">四大核心优势，打造最专业的娱乐爆料聚合平台。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresItems.map((item, index) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-7 text-center hover:border-primary-200/70 transition-colors duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100/70 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}